import React from "react";
import { Link } from "../../lib/Link";

export const options = type => {
  return (
    <div className="options">
      <div className="message">
        <div className="title">運搬・各種オプション</div>
        <div>安心保証パックなどのご紹介</div>
      </div>
      <div className="collection">
        <Link to="/service/#service_02" className="link item">
          <div className="infomation">重たい家具も手ぶらでラクラク収納</div>
          <div className="title justify">
            <span>ハロー宅配便</span>
            <span>サービス</span>
          </div>
          <div className="price">
            <span>¥23,000〜</span>
          </div>
        </Link>
        <Link to="/service/#service_04" className="link item">
          <div className="infomation">
            鍵の再発行など、もしもの時のために･･･
          </div>
          <div className = "warranty">
            <span>ハロー安心保証パック　¥550</span><br/>
            <br/>
            <span>ハロー安心保証パック＋　¥880</span>
          </div>
        </Link>
        <Link to="/concierge/" className="link item">
          <div className="infomation">
            お片付けの悩みをプロが解決
          </div>
          <div className = "concierge">
            <span>整理収納アドバイザーによる<br/>お片付けコンシェルジュ</span><br/>
            <br/>
            <div className = "concierge_service">
            <span>詳しくはこちら</span>
            </div>
          </div>
        </Link>
      </div>
      <Link to="/service/" className="btn center black">
        一覧を見る
      </Link>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/top/options.jsx